export class WeekDays {
  constructor(
    public monday = false,
    public tuesday = false,
    public wednesday = false,
    public thursday = false,
    public friday = false,
    public saturday = false,
    public sunday = false,
  ) {}

  static allTrue(): WeekDays {
    return new WeekDays(true, true, true, true, true, true, true);
  }

  static fromEnumArray(array: WeekDaysEnum[] = []): WeekDays {
    return new WeekDays(
      array.includes(WeekDaysEnum.Monday),
      array.includes(WeekDaysEnum.Tuesday),
      array.includes(WeekDaysEnum.Wednesday),
      array.includes(WeekDaysEnum.Thursday),
      array.includes(WeekDaysEnum.Friday),
      array.includes(WeekDaysEnum.Saturday),
      array.includes(WeekDaysEnum.Sunday),
    );
  }

  static toEnumArray(weekdays: WeekDays): WeekDaysEnum[] {
    const weekdaysArray: WeekDaysEnum[] = [];

    if (weekdays.monday) weekdaysArray.push(WeekDaysEnum.Monday);
    if (weekdays.tuesday) weekdaysArray.push(WeekDaysEnum.Tuesday);
    if (weekdays.wednesday) weekdaysArray.push(WeekDaysEnum.Wednesday);
    if (weekdays.thursday) weekdaysArray.push(WeekDaysEnum.Thursday);
    if (weekdays.friday) weekdaysArray.push(WeekDaysEnum.Friday);
    if (weekdays.saturday) weekdaysArray.push(WeekDaysEnum.Saturday);
    if (weekdays.sunday) weekdaysArray.push(WeekDaysEnum.Sunday);

    return weekdaysArray;
  }
}

export enum WeekDaysEnum {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday',
}

export const getWeekdayFromDayOfWeek = (
  dayOfWeek: number,
): WeekDaysEnum | null => {
  switch (dayOfWeek) {
    case 0:
      return WeekDaysEnum.Sunday;
    case 1:
      return WeekDaysEnum.Monday;
    case 2:
      return WeekDaysEnum.Tuesday;
    case 3:
      return WeekDaysEnum.Wednesday;
    case 4:
      return WeekDaysEnum.Thursday;
    case 5:
      return WeekDaysEnum.Friday;
    case 6:
      return WeekDaysEnum.Saturday;
    default:
      return null;
  }
};

export const returnSelectedWeekdaysAsStrings = (weekdays: WeekDays) => {
  return WeekDays.toEnumArray(weekdays);
};

export const convertWeekDayStringsInWeekdayObject = (
  weekdaysArray: string[],
) => {
  return WeekDays.fromEnumArray(weekdaysArray as WeekDaysEnum[]);
};
